export function mobileNav() {
    let mobileNavContainer = document.querySelector('#mobile-menu');    
    let button = document.querySelector('#mobile-nav-button button');
    let openIcon = button.querySelectorAll('svg')[0];
    let closeIcon = button.querySelectorAll('svg')[1];
    let menu = document.getElementById('mobile-nav-wrapper');

    // Initially hide the close icon and set the menu's max-height to 0
    closeIcon.style.display = 'none';
    menu.style.maxHeight = '0px';
    menu.style.overflow = 'hidden';
    menu.style.transition = 'max-height 0.5s ease-in-out';
    mobileNavContainer.classList.remove('hidden')

    function toggleMenu() {
        if (menu.style.maxHeight !== '0px') {
            menu.style.maxHeight = '0px';
            openIcon.style.display = 'block';
            closeIcon.style.display = 'none';
        } else {
            menu.style.maxHeight = menu.scrollHeight + 'px';
            openIcon.style.display = 'none';
            closeIcon.style.display = 'block';
        }
    }

    button.addEventListener('click', toggleMenu);

}